var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-link',{staticStyle:{"font-size":"12px"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.clickModule(_vm.value)}}},[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }